import React from 'react'
import Player from 'react-player'
import { StaticImage } from 'gatsby-plugin-image'

export default function Explainer() {
  return (
    <>
      <div className="et_pb_row">
        <div className="et_pb_column et_pb_column_4_4">
          <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
            <h2 style={{ textAlign: 'center' }}>How Does It Work?</h2>
          </div>
        </div>
      </div>
      <div className="et_pb_row">
        <div className="et_pb_column et_pb_column_4_4">
          <div
            className="et_pb_text et_pb_bg_layout_light et_pb_text_align_center"
            style={{
              maxWidth: '960px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <Player
              className="react-player"
              src="https://affio-1.wistia.com/medias/4yar2b07v6"
              width="100%"
              height="540px"
            />
          </div>
        </div>
      </div>
      <div className="et_pb_row">
        <div className="et_pb_column et_pb_column_1_4">
          <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_center">
            <StaticImage
              src="../../images/icons/heart.png"
              alt="Heart"
              className="aligncenter size-full"
              height={74}
              objectFit="none"
            />
          </div>
          <div className="et_pb_blurb et_pb_bg_layout_light et_pb_text_align_center">
            <div className="et_pb_blurb_content">
              <h4>Family &amp; Friends</h4>
              Tell us a few details about the important people in your life.
            </div>
          </div>
        </div>
        <div className="et_pb_column et_pb_column_1_4">
          <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_center">
            <StaticImage
              src="../../images/icons/house.png"
              alt="House"
              className="aligncenter size-full"
              height={74}
              objectFit="none"
            />
          </div>
          <div className="et_pb_blurb et_pb_bg_layout_light et_pb_text_align_center">
            <div className="et_pb_blurb_content">
              <h4>Assets</h4>
              Register the property that has the most value for you, either
              financially or emotionally, and who you share them with.
            </div>
          </div>
        </div>
        <div className="et_pb_column et_pb_column_1_4">
          <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_center">
            <StaticImage
              src="../../images/icons/speech.png"
              alt="Speech"
              className="aligncenter size-full"
              height={74}
              objectFit="none"
            />
          </div>
          <div className="et_pb_blurb et_pb_bg_layout_light et_pb_text_align_center">
            <div className="et_pb_blurb_content">
              <h4>Your Wishes</h4>
              Consider how you’d like to take care of your loved ones, and how
              you would like your estate to be distributed amongst them.
            </div>
          </div>
        </div>
        <div className="et_pb_column et_pb_column_1_4">
          <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_center">
            <StaticImage
              src="../../images/icons/pencil.png"
              alt="Pencil"
              className="aligncenter size-full"
              height={74}
              objectFit="none"
            />
          </div>
          <div className="et_pb_blurb et_pb_bg_layout_light et_pb_text_align_center">
            <div className="et_pb_blurb_content">
              <h4>Download &amp; Sign</h4>
              Make it legal by simply downloading your will and following our
              simple instructions for signature and storage.
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
